import { ExaminerProfile, ExamStatsTab } from '../../../../../store/workspace/types';
import { ApplicantFinalizeExamStatus } from '../../../../../store/workspace/types';
import { setExaminerProfileModal } from '../../../../../store/workspace/slice';
import { ChevronDownIcon, ProfileIcon } from '../../../../../assets/icons';
import { examStatusTitle } from '../../../../../utils/generalHelpers';
import { setNotification } from '../../../../../store/general/slice';
import { finalResultActions } from '../../../../../configs';
import { ForwardedRef, forwardRef, useState } from 'react';
import { useDispatch } from '../../../../../store/store';
import Loading from '../../../../../components/Loading';
import Button from '../../../../../components/Button';
import styles from './style.module.scss';
import {
    getExaminerProfileThunk,
    finalizeApplicantExamStatusThunk,
} from '../../../../../store/workspace/thunks';

interface Props {
    jobId: string | undefined;
    examinersData: ExaminerProfile[];
    fetchTablesData: (tab: ExamStatsTab) => void;
};

const FinalResultTable = forwardRef((props: Props, ref: ForwardedRef<HTMLDivElement>) => {
    const {
        jobId,
        examinersData,
        fetchTablesData,
    } = props;

    const dispatch = useDispatch();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [expandedCards, setExpandedCards] = useState<string[]>([]);

    const toggleCard = (userId: string) => {
        setExpandedCards(prev => {
            if (prev.includes(userId)) {
                return prev.filter(id => id !== userId);
            } else {
                return [...prev, userId];
            }
        });
    };

    const getExaminerProfile = (id: string) => {
        dispatch(getExaminerProfileThunk({ id, jobId }));
        dispatch(setExaminerProfileModal(true));
    };

    const finalizeApplicantExamStatus = (applicantId: string, finalize: ApplicantFinalizeExamStatus) => {
        if (!jobId) return;

        setIsSubmitting(true);
        dispatch(finalizeApplicantExamStatusThunk({
            applicantId,
            finalize,
            jobId,
        }))
            .unwrap()
            .then(() => {
                dispatch(setNotification(['Applicant exam status updated successfully', 'success']));
                fetchTablesData('finalResult');
            })
            .catch(() => {
                dispatch(setNotification(['Something went wrong,Try again...', 'error']));
            })
            .finally(() => {
                setIsSubmitting(false);
            })
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.table} ref={ref}>
                <table>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Status</th>
                            <th>Interview status (Please select the status)</th>
                            <th data-noprint="true">Info</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(examinersData && examinersData.length > 0) ? examinersData?.map(applicant => <tr>
                            <td>
                                <div className={styles.examinerName}>
                                    <span>{applicant.first_name} {applicant.family_name}</span>
                                </div>
                            </td>
                            <td>
                                <span
                                    className={styles.status}
                                    data-status={applicant.status}
                                >
                                    {examStatusTitle(applicant.status)}
                                </span>
                            </td>
                            <td>
                                <div className={styles.actions}>
                                    {finalResultActions.map(action =>
                                        <Button
                                            text={action.title}
                                            className={styles.actions_btn}
                                            type={applicant.finalize === action.id ? 'Primary' : 'Outline-Primary'}
                                            onClick={() => finalizeApplicantExamStatus(applicant.userId, action.id)}
                                        />)}
                                </div>
                            </td>
                            <td data-noprint="true" onClick={() => getExaminerProfile(applicant.userId)}><ProfileIcon /></td>
                        </tr>) : <tr>
                            <td colSpan={3}>No data.</td>
                        </tr>}
                    </tbody>
                </table>
            </div>
            {isSubmitting && <Loading />}

            <div className={styles.mobile_list}>
                {examinersData.map(applicant => {
                    const isExpanded = expandedCards.includes(applicant.userId);
                    return (
                        <div className={styles.card}>
                            <div className={styles.card_header} onClick={() => toggleCard(applicant.userId)}>
                                <span>{applicant.first_name} {applicant.family_name}</span>
                                <ChevronDownIcon style={{ transform: isExpanded ? 'rotate(180deg)' : 'none' }} />
                            </div>
                            {isExpanded && <div className={styles.card_body}>
                                <div className={styles.card_body_section}>
                                    <div className={styles.card_body_section_title}>
                                        <span>Status</span>
                                        <span className={styles.status} data-status={applicant.status}>
                                            {examStatusTitle(applicant.status)}
                                        </span>
                                    </div>
                                </div>
                                <div className={styles.card_body_section}>
                                    <div className={styles.card_body_section_title}>
                                        <span>Interview status (Please select the status)</span>
                                    </div>
                                    <div className={styles.card_body_section_content}>
                                        {finalResultActions.map(action =>
                                            <Button
                                                text={action.title}
                                                type={applicant.finalize === action.id ? 'Primary' : 'Outline-Primary'}
                                                onClick={() => finalizeApplicantExamStatus(applicant.userId, action.id)}
                                            />)}
                                    </div>
                                </div>
                            </div>}
                        </div>
                    )
                })}
            </div>
        </div>
    );
});

export default FinalResultTable;
